import axios from 'axios'

axios.defaults.headers.common['x-api-key'] = `Ck2zeFBZsr53hg8STSFzP32pu7fopte74hf2TdKD`;
// axios.defaults.headers.common['Access-Control-Allow-Methods'] = "GET,OPTIONS,POST";
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
// axios.defaults.headers.common['Access-Control-Allow-Headers'] = "Access-Control-Allow-Headers, Origin, Accept, X-Requested-With, x-apikey, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers"

export async function getDates(){
    const response = await axios.get('https://api.villalubia.com/dates', {})
    return response.data
}

// {  headers: {
//     'Access-Control-Allow-Origin': '*',
//     "Access-Control-Allow-Headers": "Access-Control-Allow-Headers, Origin, Accept, X-Requested-With, x-apikey, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers",
//     "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT"

//   }}





